import { ComponentType, FC } from 'react';
import { useFeatureFlag } from './hooks/useFeatureFlag';

/**
 * a HoC that should make rendering with feature flags easier!
 */
type FlaggedComponentProps = {
  featureFlag?: string;
};

export const FlaggedComponent: FC<React.PropsWithChildren<FlaggedComponentProps>> = ({
  children,
  featureFlag = '',
}) => {
  const isFeatureFlagEnabled = useFeatureFlag(featureFlag);
  return <>{isFeatureFlagEnabled && children}</>;
};

export function withFeatureFlag<T extends JSX.IntrinsicAttributes>(
  featureFlag: string,
  Component: ComponentType<React.PropsWithChildren<T>>,
) {
  return (props: T) => (
    <FlaggedComponent featureFlag={featureFlag}>
      <Component {...props} />
    </FlaggedComponent>
  );
}
